<template>
  <!-- 省市区 -->
  <div>
    <el-select class="arriveClass" v-model="province" :placeholder="Language('省份')" @change="provinceChange($event)">
      <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
    <el-select class="arriveClass" v-model="citty" :placeholder="Language('城市')" @change="cityChange($event)">
      <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
    <el-select class="arriveClass" v-model="area" :placeholder="Language('地区')">
      <el-option v-for="item in countyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
  </div>
</template>

<script>
  import { getqueryAreaList } from '@/http/BaseData'
  export default {
    data(){
      return{
        provinceList:[],
        cityList:[],
        countyList:[],
        province:"",
        citty:"",
        area:"",
      }
    },
    props:{
      default:{//回显信息
        type: Object,
        default: () => ({}) 
      }
    },
    watch:{
      default:{
        immediate: true,//先与created执行
        deep:true,
        handler: function (newV, oldV) {
          if(JSON.stringify(newV) ==JSON.stringify(oldV))return
          if(newV.province !=undefined && newV.province !='undefined' &&newV.province !=null && newV.province !=''){
            this.province = newV.province;
            this.provinceChange(this.province)
          }
          if(newV.citty !=undefined && newV.citty !='undefined' &&newV.citty !=null && newV.citty !=''){
            this.citty = newV.citty;
          }
          if(newV.area !=undefined && newV.area !='undefined' &&newV.area !=null && newV.area !=''){
            this.area = newV.area;
          }
        },
      },
    },
    methods:{
      getProvinceList(){
        if(this.provinceList.length>0) return
        getqueryAreaList({
          id: 0
        }).then((res)=>{
          if(res.status ==200){
            this.provinceList = res.data;
          }else{
            this.$Msg.error(res.retMsg)
          }
        })
      },
      provinceChange(data){//省切换
        this.area="";//地区
        this.citty= "";//城市
        this.countyList = [];
        if(data !="" && data !=null){
          let params ={'id':data}
          getqueryAreaList(params,{}).then((res)=>{
            if(res.status ==200){
              this.cityList = res.data;
              if(this.area!=''){
                this.cityChange(this.citty)
              }
              console.log(this.citty)
            }
          })
        }
      },
      cityChange(data){
      if(data !="" && data !=null){
          let params ={'id':data}
          getqueryAreaList(params,{}).then((res)=>{
            if(res.status ==200){
              this.countyList = res.data;
            }
          })
        }
      },
    },
    created(){
      // this.getProvinceList()
    }
  }
</script>

<style scoped lang="scss">
.arriveClass{
  margin-bottom: 5px;
  width: 50%;
  float: left;
  &:last-child{
    margin-bottom: 0;
  }
}
</style>


// WEBPACK FOOTER //
// AreaSelect.vue?9682c688